import React from 'react';
import { connect } from 'react-redux';

import { useNavigate } from "react-router-dom";

import { closeAddReclamationDialog } from 'store/common/commonActions';
import AddReclamationDialog from './AddReclamationDialog';

const AddReclamationDialogContainer = ({
    open,
    reclamationLiee,
    reclamationParentId,
    closeAddReclamationDialog,
    infosLogistique }) => {

    const navigate = useNavigate();

    if (!open) return null;

    return (
        <AddReclamationDialog
            onClose={closeAddReclamationDialog}
            reclamationLiee={reclamationLiee}
            reclamationParentId={reclamationParentId}
            infosLogistique={infosLogistique}
            navigate={navigate}
        />
    );
};

const mapStateToProps = state => ({
    open: state.common.addReclamationDialogOpen,
    reclamationLiee: state.common.addReclamation.reclamationLiee,
    reclamationParentId: state.common.addReclamation.reclamationParentId,
    infosLogistique: state.common.addReclamation.infosLogistique
});

const mapDispatchToProps = {
    closeAddReclamationDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddReclamationDialogContainer);

